import styled from 'styled-components/macro'

import { Card, Layout, ProgressBar, Text } from '@loadsmart/loadsmart-ui'

import { plural } from 'core/utils/string'

import { type Shipper } from '../../domain/Shipper'
import { ShipperHeader } from '../ShipperHeader'

const ProgressBarWrapper = styled(Layout.Stack)`
  flex-grow: 1;
`

export type BulkSpotQuoteHeaderProps = {
  shipper: Shipper
  totalRatesCount: number
  submittedRatesCount: number
}

export function BulkSpotQuoteHeader({
  shipper,
  totalRatesCount,
  submittedRatesCount,
}: BulkSpotQuoteHeaderProps) {
  return (
    <Card>
      <Card.Body>
        <Layout.Group align="center" space="xl">
          <ShipperHeader shipper={shipper} />
          <ProgressBarWrapper space="s">
            <Text variant="heading-sm-bold">
              {submittedRatesCount} of {totalRatesCount} {plural('lane', totalRatesCount)} submitted
              to the shipper
            </Text>
            <ProgressBar
              status="success"
              value={(submittedRatesCount / totalRatesCount) * 100}
              showLine
              rounded
            />
          </ProgressBarWrapper>
        </Layout.Group>
      </Card.Body>
    </Card>
  )
}
